import { render, staticRenderFns } from "./activiti-model.vue?vue&type=template&id=700d282b&scoped=true"
import script from "./activiti-model.vue?vue&type=script&lang=js"
export * from "./activiti-model.vue?vue&type=script&lang=js"
import style0 from "./activiti-model.vue?vue&type=style&index=0&id=700d282b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d282b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('700d282b')) {
      api.createRecord('700d282b', component.options)
    } else {
      api.reload('700d282b', component.options)
    }
    module.hot.accept("./activiti-model.vue?vue&type=template&id=700d282b&scoped=true", function () {
      api.rerender('700d282b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/system/activiti/activiti-model.vue"
export default component.exports